export default __webpack_public_path__ + "static/media/pixeboy.dbede242.ttf";